import { hotjar } from "react-hotjar";
import { log } from "./helpers";

const FLAG_NAME = "dispatch_enable_hotjar";

export const initialize = (user: User) => {
  if (!user.featureFlags.includes(FLAG_NAME)) {
    log(`[${FLAG_NAME}] Not enabled for user: ${user.id}`);
    return;
  }

  if (Number(HOTJAR_HJID) === 0) {
    log(`[${FLAG_NAME}] Not enabled because HOTJAR_HJID is 0 (not configured)`);
    return;
  }

  hotjar.initialize(HOTJAR_HJID, HOTJAR_HJSV);
};
